<template>
  <div class="calendar-root">
    <!--<div class="input-date" @click="toggleCalendar()"> {{getDateString(dateRange.start)}} - {{getDateString(dateRange.end)}}</div>-->
    <div class="calendar" :class="{'calendar-mobile ': isCompact, 'calendar-right-to-left': isRighttoLeft}">
      <div class="calendar-range q-pa-sm" :class="{'calendar-range-mobile ': isCompact}"
           v-if="!showMonth || !isCompact">
        <div class="calendar_preset">
          <q-btn
            class="calendar_preset-ranges"
            v-for="(item, idx) in finalPresetRanges"
            :key="idx"
            @click="updatePreset(item)"
            :class="{'active-preset': presetActive === item.label, 'q-mr-xs': true}"
            :label="item.label"
            flat
            no-caps
            no-wrap
            color="primary"
          />
          <!--<li><button class="calendar-btn-apply" @click="setDateValue()">{{captions.ok_button}}</button></li>-->
        </div>
        <div class="calendar_reset">
          <q-btn
            @click="reset()"
            color="negative"
            flat
            no-caps
            no-wrap
            label="Очистить"
          />
        </div>
      </div>
      <div class="calendar-wrap ">
        <div class="calendar_month_left q-pa-sm" :class="{'calendar-left-mobile': isCompact}">
          <div class="months-text">
            <q-btn
              @click="goPrevMonth"
              flat
              icon="keyboard_arrow_left"
            />
            {{monthsLocale[activeMonthStart] +' '+ activeYearStart}}
          </div>
          <ul :class="s.daysWeeks">
            <li v-for="item in shortDaysLocale" :key="item">{{item}}</li>
          </ul>
          <ul v-for="r in 6" :class="[s.days]" :key="r">
            <li
              :class="[getDateSelectedClass(r, i, 'first', startMonthDay, endMonthDate), {
                [s.daysInRange]: isDateInRange(r, i, 'first', startMonthDay, endMonthDate),
                [s.daysAvailable]: isDateAvailable(r, i, 'first', startMonthDay, endMonthDate),
                [s.dateDisabled]: isDateDisabled(r, i, startMonthDay, endMonthDate)
              }]"
              v-for="i in numOfDays"
              :key="i"
              v-html="getDayCell(r, i, startMonthDay, endMonthDate)"
              @click="selectFirstItem(r, i)"
              @mouseover="setAvailableDate(r, i, 'first')"
            ></li>
          </ul>
        </div>
        <div class="calendar_month_right q-pa-sm" v-if="!isCompact">
          <div class="months-text">
            {{monthsLocale[startNextActiveMonth] +' '+ activeYearEnd}}
            <q-btn
              @click="goNextMonth"
              flat
              icon="keyboard_arrow_right"
            />
          </div>
          <ul :class="s.daysWeeks">
            <li v-for="item in shortDaysLocale" :key="item">{{item}}</li>
          </ul>
          <ul v-for="r in 6" :class="[s.days]" :key="r">
            <li
              :class="[getDateSelectedClass(r, i, 'second', startNextMonthDay, endNextMonthDate), {
                [s.daysInRange]: isDateInRange(r, i, 'second', startNextMonthDay, endNextMonthDate),
                [s.daysAvailable]: isDateAvailable(r, i, 'second', startNextMonthDay, endNextMonthDate) && !isDateDisabled(r, i, startNextMonthDay, endNextMonthDate),
                [s.dateDisabled]: isDateDisabled(r, i, startNextMonthDay, endNextMonthDate)
              }]"
              v-for="i in numOfDays"
              :key="i" 
              v-html="getDayCell(r, i, startNextMonthDay, endNextMonthDate)"
              @click="selectSecondItem(r, i);"
              @mouseover="setAvailableDate(r, i, 'second')"
            ></li>
          </ul>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  import helpers from './helpers';

  import {
    QBtn
  } from 'quasar';

  export default {
    name: 'RangedatePicker',
    mixins: [helpers],
    components: {
      QBtn
    }
  };
</script>

<style lang="scss" scoped>
  .input-date {
    display: block;
    border: 1px solid #ccc;
    padding: 5px;
    font-size: 14px;
    width: 230px;
    cursor: pointer;
  }

  .input-date::after {
    content: "▼";
    float: right;
    font-size: smaller;
  }

  .active-preset {
    border: 1px solid #0096d9;
    color: #0096d9;
    border-radius: 3px;
  }

  .months-text {
    position: relative;
    padding: 10px 0;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
  }

  .months-text .left {
    float: left;
    cursor: pointer;
    width: 16px;
    height: 16px;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDMxLjQ5NCAzMS40OTQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMxLjQ5NCAzMS40OTQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTEwLjI3Myw1LjAwOWMwLjQ0NC0wLjQ0NCwxLjE0My0wLjQ0NCwxLjU4NywwYzAuNDI5LDAuNDI5LDAuNDI5LDEuMTQzLDAsMS41NzFsLTguMDQ3LDguMDQ3aDI2LjU1NCAgYzAuNjE5LDAsMS4xMjcsMC40OTIsMS4xMjcsMS4xMTFjMCwwLjYxOS0wLjUwOCwxLjEyNy0xLjEyNywxLjEyN0gzLjgxM2w4LjA0Nyw4LjAzMmMwLjQyOSwwLjQ0NCwwLjQyOSwxLjE1OSwwLDEuNTg3ICBjLTAuNDQ0LDAuNDQ0LTEuMTQzLDAuNDQ0LTEuNTg3LDBsLTkuOTUyLTkuOTUyYy0wLjQyOS0wLjQyOS0wLjQyOS0xLjE0MywwLTEuNTcxTDEwLjI3Myw1LjAwOXoiIGZpbGw9IiMwMDZERjAiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==");
  }

  .months-text .right {
    float: right;
    cursor: pointer;
    width: 16px;
    height: 16px;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDMxLjQ5IDMxLjQ5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMS40OSAzMS40OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiPgo8cGF0aCBkPSJNMjEuMjA1LDUuMDA3Yy0wLjQyOS0wLjQ0NC0xLjE0My0wLjQ0NC0xLjU4NywwYy0wLjQyOSwwLjQyOS0wLjQyOSwxLjE0MywwLDEuNTcxbDguMDQ3LDguMDQ3SDEuMTExICBDMC40OTIsMTQuNjI2LDAsMTUuMTE4LDAsMTUuNzM3YzAsMC42MTksMC40OTIsMS4xMjcsMS4xMTEsMS4xMjdoMjYuNTU0bC04LjA0Nyw4LjAzMmMtMC40MjksMC40NDQtMC40MjksMS4xNTksMCwxLjU4NyAgYzAuNDQ0LDAuNDQ0LDEuMTU5LDAuNDQ0LDEuNTg3LDBsOS45NTItOS45NTJjMC40NDQtMC40MjksMC40NDQtMS4xNDMsMC0xLjU3MUwyMS4yMDUsNS4wMDd6IiBmaWxsPSIjMDA2REYwIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=");
  }

  .calendar-right-to-left {
    margin-left: -460px;
  }

  .calendar {
    display: block;
    width: 500px;
    font-size: 12px;
    background: #fff;
  }

  .calendar-head h2 {
    padding: 20px 0 0 20px;
    margin: 0;
  }

  .close:hover {
    cursor: pointer;
  }

  .close {
    float: right;
    padding: 0 10px;
    margin-top: -35px;
    font-size: 32px;
    font-weight: normal;
  }

  .calendar ul {
    list-style-type: none;
  }

  .calendar-wrap {
    display: flex;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }

  .calendar-range {
    display: flex;
    justify-content: space-between;
  }

  .calendar_preset {
    display: flex;
  }

  .calendar-left-mobile {
    width: 100% !important;
  }

  .calendar_month_left,
  .calendar_month_right {
    flex: 1 0 auto;
  }

  .calendar_weeks {
    display: flex;
    margin: 0;
    padding: 8px 0;
    width: auto;
  }

  .calendar_weeks li {
    flex: 1 0 0;
    color: #999;
    text-align: center;
    font-weight: 700;
  }

  .calendar_days {
    display: flex;
    margin: 0;
    padding: 0;
  }

  .calendar_days li {
    flex: 1 0 0;
    color: #333;
    text-align: center;
    cursor: pointer;
    line-height: 2.5em;
    transition: background 0.1s;
  }

  .calendar_preset li {
    line-height: 2.6em;
    width: auto;
    display: block;
  }

  .calendar_days li:not(.calendar_days_selected):hover {
    background: #eee;
    color: #000;
  }

  li.calendar_days--disabled {
    pointer-events: none;
  }

  li.calendar_days_selected {
    background: #4d96d6 !important;
    color: #fff !important;
    
    &.start {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    
    &.end {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  li.calendar_days_available {
    background: #ebf4f8;
    color: #000;
  }

  li.calendar_days_in-range {
    background: #e6f3ff;
  }

  .calendar_preset {
    padding: 0;
  }

  .calendar_preset li.calendar_preset-ranges {
    padding: 0 10px;
    margin-bottom: 5px;
    cursor: pointer;
  }

  .calendar_preset li.calendar_preset-ranges:hover {
    background: #eee;
  }

  .calendar-mobile {
    width: 260px;
    z-index: 1;
    box-shadow: none;
  }

  .calendar-range-mobile {
    width: 90%;
    padding: 2px;
    border-left: none;
    margin: -20px 0;
  }

  .calendar-btn-apply {
    width: 100%;
    background: #f7931e;
    color: #fff;
    border: none;
    padding: 5px;
    font-size: 14px;
  }

  .calendar_preset .q-btn,
  .calendar_reset .q-btn {
    padding: 4px 8px;
    font-size: 12px;
    border: 1px solid transparent;

    &.active-preset {
      border-color: currentColor;
    }
  }

  .calendar_month_left,
  .calendar_month_right {
    position: relative;
  }

  .calendar_month_left .q-btn,
  .calendar_month_right .q-btn {
    position: absolute;
    top: 2px;
    font-size: 16px;
    min-height: 30px;
    padding: 4px 5px;

  }

  .calendar_month_left .q-btn {
    left: 0;
  }

  .calendar_month_right .q-btn {
    right: 0;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/RangedatePicker/RangedatePicker.vue